import { render, staticRenderFns } from "./SecurityFallbackSettingsTab.vue?vue&type=template&id=56310643&scoped=true"
import script from "./SecurityFallbackSettingsTab.vue?vue&type=script&lang=js"
export * from "./SecurityFallbackSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SecurityFallbackSettingsTab.vue?vue&type=style&index=0&id=56310643&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56310643",
  null
  
)

export default component.exports